import { T } from "@freightsimple/ui-core/Typography/T";

export interface QuoteScreenShipmentGroup {
  pickupCity: string;
  pickupStateOrProvinceCode: string;
  deliveryCity: string;
  deliveryStateOrProvinceCode: string;
}

interface QuoteScreenGroupHeaderProps {
  group: QuoteScreenShipmentGroup;
}

export function DashboardQuoteScreenGroupHeader(
  props: QuoteScreenGroupHeaderProps,
) {
  const { group } = props;
  return (
    <T weight="medium">
      {group.pickupCity}, {group.pickupStateOrProvinceCode} to{" "}
      {group.deliveryCity}, {group.deliveryStateOrProvinceCode}
    </T>
  );
}
